export default "__VITE_ASSET__DLbS3WnS__"